var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTablet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.37054 3.07143C2.37054 2.8441 2.46084 2.62608 2.62159 2.46534C2.78233 2.30459 3.00035 2.21429 3.22768 2.21429H15.2277C15.455 2.21429 15.673 2.30459 15.8338 2.46534C15.9945 2.62608 16.0848 2.8441 16.0848 3.07143V18.5C16.0848 18.7273 15.9945 18.9453 15.8338 19.1061C15.673 19.2668 15.455 19.3571 15.2277 19.3571H3.22768C3.00035 19.3571 2.78233 19.2668 2.62159 19.1061C2.46084 18.9453 2.37054 18.7273 2.37054 18.5V3.07143ZM3.22768 0.5C2.54569 0.5 1.89164 0.770918 1.4094 1.25315C0.927168 1.73539 0.65625 2.38944 0.65625 3.07143V18.5C0.65625 19.182 0.927168 19.836 1.4094 20.3183C1.89164 20.8005 2.54569 21.0714 3.22768 21.0714H15.2277C15.9097 21.0714 16.5637 20.8005 17.046 20.3183C17.5282 19.836 17.7991 19.182 17.7991 18.5V3.07143C17.7991 2.38944 17.5282 1.73539 17.046 1.25315C16.5637 0.770918 15.9097 0.5 15.2277 0.5H3.22768ZM6.65625 17.6429H11.7991V15.9286H6.65625V17.6429Z",
    fill: "#BCBCBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTablet);
export default __webpack_public_path__ + "static/media/icon-tablet.eb576440bcfdc19d12bc5b335731b268.svg";
export { ForwardRef as ReactComponent };